<a mat-button color="primary" (click)="startDownload()">
    {{status}}
</a>